import apiClient from '@u/apiClient'
import GetArtisanCommandsController from '@/wayfinder/actions/App/Http/Controllers/SAManagement/GetArtisanCommandsController'
import GetCommandRunsController from '@/wayfinder/actions/App/Http/Controllers/SAManagement/GetCommandRunsController'
import CreateCommandRunController from '@/wayfinder/actions/App/Http/Controllers/SAManagement/CreateCommandRunController'
import DeleteCommandRunController from '@/wayfinder/actions/App/Http/Controllers/SAManagement/DeleteCommandRunController'
import GetScheduledTasksController from '@/wayfinder/actions/App/Http/Controllers/SAManagement/GetScheduledTasksController'
import RunScheduledTaskNowController from '@/wayfinder/actions/App/Http/Controllers/SAManagement/RunScheduledTaskNowController'
import GetImportSourcesController from '@/wayfinder/actions/App/Http/Controllers/SAManagement/GetImportSourcesController'
import GetTenantDumpsController from '@/wayfinder/actions/App/Http/Controllers/SAManagement/GetTenantDumpsController'

export default {
  fetchArtisanCommands({}) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetArtisanCommandsController.get())
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchCommandRuns({}, { source }: { source?: string } = {}) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetCommandRunsController.get(), {
          params: source ? { source } : {}
        })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  createCommandRun({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateCommandRunController.post(), payload)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  deleteCommandRun({ commit }, { run_id }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteCommandRunController.delete({ commandRun: run_id }))
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchScheduledTasks({}) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetScheduledTasksController.get())
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  runScheduledTaskNow({}, { command }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(RunScheduledTaskNowController.post(), { command })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchImportSources({}) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetImportSourcesController.get())
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchTenantDumps({}, { tenantId }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetTenantDumpsController.get(), {
          params: { tenant_id: tenantId }
        })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  }
}
